// extracted by mini-css-extract-plugin
export default {"container":"fdiTable_container__drLPM","header":"fdiTable_header__8mWbI"};